// extracted by mini-css-extract-plugin
export default {"userActivity":"ActivityAndStatistics_userActivity__sq5if","isFirst":"ActivityAndStatistics_isFirst__zKkHX"};